module.exports = __webpack_public_path__ + "img/Protoio-logo.eecd730a.svg";